export default __webpack_public_path__ + "static/media/36.a147888c.png";